var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HeaderDashboardCards,{attrs:{"data-testid":"employees-header-dashboard","aria-label":"Employees summary","metrics":_setup.cards,"variant":"count-only","columns":_setup.cards.length === 5 ? 5 : 4,"action-label":_vm.activeIndicator ? 'Clear Filter' : 'Apply Filter'},on:{"select":_setup.handleSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }